import React, { Component } from 'react'

export default class About extends Component {
  render() {
    return (
      <div className='container'>
        <div className='row'>
          <div className='col-10 mx-auto text-center text-title text-uppercase pt-5'>
            <h1 className='display-3'>About Us</h1>
            <h2>Ginkgo Bleu Leatherworks</h2>
            <h3>was founded in 2023</h3>
          </div>
        </div>
      </div>
    )
  }
}
